import { isRef, WritableComputedRef, nextTick } from 'vue';
import { I18n, I18nOptions, createI18n, Locale } from 'vue-i18n';
import merge from 'lodash.merge';

import { getConfig } from '../config';

export const AVAILABLE_LOCALES = ['en', 'cs'];

const getNavigatorLocale = () => {
  const [lang] = globalThis.navigator.language.split('-');
  if (AVAILABLE_LOCALES.includes(lang)) {
    return lang;
  }

  return AVAILABLE_LOCALES[0];
};

export const setI18nLanguage = (_i18n: I18n, locale: string = 'en') => {
  // `_i18n.mode` is deprecated (removed in vue-i18n v12); composition-mode instances expose
  // `global.locale` as a ref, legacy-mode instances expose it as a plain string — branch on
  // that instead, which keeps both modes working the same as before.
  if (isRef(_i18n.global.locale)) {
    (_i18n.global.locale as WritableComputedRef<Locale>).value = locale;
  } else {
    _i18n.global.locale = locale;
  }
};

export const setupI18n = (options: I18nOptions) => {
  const i18n = createI18n(options);
  setI18nLanguage(i18n, options.locale);
  return i18n;
};

export const i18n = setupI18n({
  legacy: false,
  locale: getNavigatorLocale(),
  fallbackLocale: getNavigatorLocale(),
});

export const loadLocaleMessages = async (locale?: string | null) => {
  const lang = locale ?? getNavigatorLocale();
  const [commonMessages, tenantMessages] = await Promise.all([
    import(`../lang/${lang}.json`),
    import(`../lang/${getConfig().TENANT}/${lang}.json`),
  ]);

  const messages = merge(commonMessages.default, tenantMessages.default);

  // set locale and locale message
  i18n.global.setLocaleMessage(lang, messages);
  setI18nLanguage(i18n, lang);

  return nextTick();
};
